import React, { Component } from 'react'

class RenderInput  extends Component {
	render() {
		const { input, id, type, disabled, label, placeholder, desc, min, max , className} = this.props

		return(
			<div>
			  <label>{label}</label>
			    <input type={type} {...input} {...this.props} placeholder={placeholder} className={className} id={id} disabled={disabled} min={parseInt(min)} max={parseInt(max)}/>
			</div>
		)
	}
}


export default RenderInput
